import { Text } from '@factorialco/deprecated-design-system'

export const Separator = () => {
  return (
    <Text.Normal color="grey400" size="100">
      |
    </Text.Normal>
  )
}
